module.exports = __webpack_public_path__ + "static/img/wisdom.df9717da.png";